<app-ets-component-router [embedName]="embedName">
  <section class="etsContentWrapper etsWrapper">
    <app-ets-calendar [embedName]="embedName" [identifier]="identifier" class="etsCalendar"></app-ets-calendar>
  </section>
</app-ets-component-router>
